import React, { useState, useCallback, useEffect, useRef } from "react";
import ExtrasModal from "./ExtrasModal";
import "./DishPage.css";

function formatPrice(price) {
  if (price === undefined || price === null) return "";
  return new Intl.NumberFormat("es-CO").format(Number(price));
}

export default function DishPage({ dish }) {
  const [showModal, setShowModal] = useState(false);
  const sinStock = Number(dish.stock) <= 0;

  const btnRef = useRef(null);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  useEffect(() => {
    const slot = document.getElementById("add-btn-slot");

    if (btnRef.current && slot) {
      slot.innerHTML = "";
      slot.appendChild(btnRef.current);
    }
  }, [dish]);

  if (!dish || !dish.price || !dish.name) {
    return <div className="dish-loading">Cargando...</div>;
  }

  return (
    <div className="dish-container">
      {/* Imagen */}
      <div className="dish-image-wrapper">
        <img
          key={dish.id}
          src={dish.image}
          alt={dish.name}
          className="dish-image"
        />

        <div className="dish-overlay">
          <h2 className="dish-title">{dish.name}</h2>

          {dish.description && (
            <p className="dish-description">{dish.description}</p>
          )}

          <span className="dish-price">${formatPrice(dish.price)}</span>

          {sinStock && <div className="dish-out-stock">Sin stock</div>}
        </div>
      </div>

      {/* Indicadores */}
      <div className="scroll-hint-left">‹</div>
      <div className="scroll-hint-right">›</div>

      {/* Botón */}
      <button
        ref={btnRef}
        className={`add-btn ${sinStock ? "add-btn-disabled" : ""}`}
        onClick={!sinStock ? openModal : undefined}
        disabled={sinStock}
        aria-label={`Agregar ${dish.name}`}
      >
        {sinStock ? "Sin stock" : "Agregar"}
      </button>

      {/* Modal */}
      {showModal && (
        <ExtrasModal
          dish={dish}
          maxAcompanamientos={dish.category === "Menu Ejecutivo" ? 1 : 3}
          onClose={closeModal}
        />
      )}
    </div>
  );
}
